export type ClaimQuery = string | { and: ClaimQuery[]; or: ClaimQuery[] };

export default function resolveClaimQuery(query: ClaimQuery, userClaims: string[]): boolean {
  if (typeof query === 'string') {
    return userClaims.some((claim) => new RegExp(`^${claim.replace('*', '.+')}$`).test(query));
  }

  let matches = true;

  if (query.and) {
    matches = query.and.every((q) => resolveClaimQuery(q, userClaims));
  }

  if (query.or) {
    matches ||= query.or.some((q) => resolveClaimQuery(q, userClaims));
  }

  return matches;
}
